/*global document*/

import React, { Component } from "react"
import Components from "../index"
import GlobalContent from "../global-content"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import _ from "lodash"
import SbEditable from "storyblok-react"

class GlobalReference extends Component {
  render() {
    const { blok } = this.props
    return (
      <StaticQuery
        query={graphql`
          query {
            allStoryblokEntry(
              filter: { field_component: { eq: "globalcontent" } }
            ) {
              edges {
                node {
                  uuid
                  content
                }
              }
            }
          }
        `}
        render={(data) => {
          let cmp
          if (data && data.allStoryblokEntry) {
            data.allStoryblokEntry.edges.filter((e) => {
              if (e.node.uuid === blok.reference) {
                const block = JSON.parse(e.node.content)
                return (cmp = (
                  <SbEditable content={blok}>
                    <GlobalContent key={e.node.uuid} blok={block} />
                  </SbEditable>
                ))
              }
              return cmp
            })
          }
          return cmp
        }}
      />
    )
  }
}

GlobalReference.propTypes = {
  blok: PropTypes.shape({}),
}

export default GlobalReference
